import ProductCard, { ProductCardProps } from '@components/Navigation/_ProductCard';
import classNames from 'classnames';

interface ProductListProps {
  title?: string;
  products: Array<ProductCardProps>;
  primaryHeader?: string;
  secondaryHeader?: string;
}

const ProductList = ({ products, title, primaryHeader, secondaryHeader }: ProductListProps) => {
  if (!products?.length) return null;
  const hasImages = products.some((product) => product.image?.image?.url);
  return (
    <div className="tw-text-neutral-500 tw-flex tw-flex-col tw-gap-y-4 tw-px-4 sm:tw-px-0">
      {title && <h5 className="tra-text-web-sub-2 md:tw-text-xl ">{title}</h5>}
      <ul
        className={classNames(
          'tw-grid sm:tw-grid-cols-3 tw-gap-x-6 tw-gap-y-5 sm:tw-gap-y-10 tw-list-none tw-pl-0',
          !hasImages && 'tw-grid-cols-2',
        )}
      >
        {products.filter(Boolean).map((product, i) => (
          <li key={i}>
            <ProductCard
              {...product}
              primaryHeader={primaryHeader}
              secondaryHeader={secondaryHeader}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductList;
